module.exports = __webpack_public_path__ + "static/media/Kneecap.ec1459d9.png";